import { z } from 'zod';
import { DatabaseAnalysisStatus } from 'libs/end-to-end/src/types/databases/analysis/database-analysis-status';

export const UnixTimestamp = z.number();

export type UnixTimestamp = z.infer<typeof UnixTimestamp>;

export const DatabaseAnalysis = z.object({
  id: z.string(),
  organizationId: z.string(),
  databaseId: z.string(),
  databaseRevisionId: z.string(),
  runAt: UnixTimestamp,
  completedAt: UnixTimestamp.optional(),
  databaseAnalysisPipelineExecutionArn: z.string().optional(),
  status: DatabaseAnalysisStatus,
});

export type DatabaseAnalysis = z.infer<typeof DatabaseAnalysis>;
